import { useWindowStore } from '../../stores/windowStore'
import { Window } from './Window'
import { AppContent } from '../../applications/AppContent'
import { AppErrorBoundary } from './AppErrorBoundary'

export function WindowManager() {
  const windows = useWindowStore((state) => state.windows)

  return (
    <>
      {windows.map((window) => (
        <Window key={window.id} window={window}>
          <AppErrorBoundary windowId={window.id} appId={window.appId}>
            <AppContent appId={window.appId} />
          </AppErrorBoundary>
        </Window>
      ))}
    </>
  )
}
